import React, { useState, useEffect } from "react"
import TitleHeader from "components/presenters/header/TitleHeader"
import server from "server/serverController2"
import CenterModal from "components/presenters/modal/CenterModal"
import {
	Section,
	SectionHeader,
	SectionBody,
	OptionList,
	SectionItem,
	SectionClickItem,
	SectionExternalItem,
} from "./style"

export default function SettingLayout() {
	//Center Modal State
	const [initCenterModal, setInitCenterModal] = useState(false)
	const [centerModalVisible, setCenterModalVisible] = useState(false)
	const [centerModalDataList, setCenterModalDataList] = useState({})
	const [onModalComplete, setOnModalComplete] = useState(null)
	const [onModalCancel, setOnModalCancel] = useState(null)

	//Init Center Modal State
	useEffect(() => {
		if (initCenterModal === true) {
			setCenterModalVisible(false)
			setCenterModalDataList({})
			setOnModalComplete(null)
			setOnModalCancel(null)
			setInitCenterModal(false)
		}
	}, [initCenterModal])

	const triggerLogout = () => {
		let data = {}
		server.deleteRequestData(`auth`, {}, (res) => {
			if (res.success !== 1) {
				setCenterModalVisible(true)
				setCenterModalDataList({
					description: `로그아웃에 실패했어요\n 관리자에게 문의해주세요.`,
				})
				setOnModalComplete(() => () => {
					setInitCenterModal(true)
				})
				return
			}
			document.location = "/"
		})
	}

	return (
		<Section>
			<SectionHeader>
				<TitleHeader title={"설정"} borderbottom={"solid calc(100vw*(1/375)) #d5d5d5"} />
			</SectionHeader>
			<SectionBody>
				<OptionList>
					<SectionItem to={`/mypage/setting/notification`}>알림설정</SectionItem>
					<SectionItem to={`/mypage/setting/notice`}>공지사항</SectionItem>
					<SectionExternalItem
						href={`https://pf.kakao.com/_gmtJs/chat`}
						target={"_blank"}
					>
						제휴문의
					</SectionExternalItem>
				</OptionList>
				<OptionList noborder>
					<SectionClickItem
						onClick={() => {
							setCenterModalVisible(true)
							setCenterModalDataList({
								title: `로그아웃`,
								description: `로그아웃 하시겠어요?`,
							})
							setOnModalComplete(() => () => {
								setInitCenterModal(true)
								triggerLogout()
							})
							setOnModalCancel(() => () => {
								setInitCenterModal(true)
							})
						}}
					>
						로그아웃
					</SectionClickItem>
					<SectionItem to={`/account/delete`}>회원탈퇴</SectionItem>
				</OptionList>
				{/*<Setlistinner> 
				<SetList listname={"알림설정"} path={"/mypage/setting/notification"} />
				<SetList listname={"공지사항"} path={"/mypage/setting/notice"} />
				<SetListExternal listname={"1:1 문의"} link={"http://pf.kakao.com/_gmtJs/chat"}/> 
				<SetList listname={"약관 및 정책"} path={"/mypage/policy/list"}/>
				<SetListExternal listname={"제휴문의"} link={"http://pf.kakao.com/_gmtJs/chat"}/>
			</Setlistinner>

			<Setlistinner>
				<SetListClick listname={"로그아웃"} clickModal={()=>{setModalOption("logout");}} />
				<SetList listname={"회원탈퇴"} path={'/account/delete'}/>
			</Setlistinner>*/}
				<CenterModal
					modalVisible={centerModalVisible}
					setModalVisible={setCenterModalVisible}
					dataList={centerModalDataList}
					onCancel={onModalCancel}
					onComplete={onModalComplete}
				/>
			</SectionBody>
		</Section>
	)
}
